import { Livewire } from "../../vendor/livewire/livewire/dist/livewire.esm";
import "./base";

Livewire.start();
